// 抖音推广页面接口
import request from "@/utils/request";
import requestXnh from "@/utils/requestForXnh";

// -------------------------- 抖音接口 -----------------------------------
// 自营-视频彩铃下单
export function addOrderListSelf(params) {
  return request({
    url: "/orderSelf/noToken/addOrderListSelf",
    method: "post",
    params: params,
    metaValue: "自营-视频彩铃下单"
  });
}

// 自营-视频彩铃下单2.0
export function addOrderListSelfTwo(params) {
  return request({
    url: "/orderSelf/noToken/addOrderListSelfTwo",
    method: "post",
    params: params,
    metaValue: "自营-视频彩铃下单2.0"
  });
}

// 电信验证码开通界面生成
export function getinfoByChinanet(params) {
  return request({
    url: "/yangguang/getinfoByChinanet",
    method: "get",
    params: params,
    onlyParams: true
  });
}

// 电信验证码开通结果回传
export function chinanetStatusReturn(params) {
  return request({
    url: "/yangguang/chinanetStatusReturn",
    method: "get",
    params: params,
    onlyParams: true
  });
}

// 自营-下发验证码
export function getSmsCode(params) {
  return request({
    url: "/sms/getSmsCode",
    method: "post",
    params: params,
    metaValue: "自营-下发验证码"
  });
}

// 自营-校验验证码
export function checkSmsCode(params) {
  return request({
    url: "/sms/checkSmsCode",
    method: "post",
    params: params,
    metaValue: "自营-校验验证码"
  });
}

// 自营-判断号码运营商
export function getphonecity(params) {
  return request({
    url: "/tools/getphonecity",
    method: "get",
    params: params,
    metaValue: "自营-判断号码运营商"
  });
}

// 自营-视频彩铃下单回传
export function postCallBack(params) {
  return request({
    url: "/orderSelf/noToken/postCallBack",
    method: "post",
    params: params,
    metaValue: "自营-视频彩铃下单回传"
  });
}

// 获取微信相关签名
export function wxGetSign(params) {
  return request({
    url: "/wxauth/getwxShareSign",
    method: "get",
    params: params,
    metaValue: "获取微信相关签名",
    onlyParams: true  // 只需传参 不需要加密
  });
}

// ----------------------- 抖音所需欣能汇接口 ------------------------------
// 获取调用阳光计划所需参数
export function miguauth(params) {
  return request({
    url: "/yangguang/getinfo",
    method: "get",
    params: params,
    metaValue: "获取调用阳光计划所需参数"
  });
}

// 根据号段获取省份城市编码-咪咕
export function getCityCode(params) {
  return request({
    url: "/yangguang/getprovincecode",
    method: "get",
    params: params,
    metaValue: "根据号段获取省份城市编码-咪咕"
  });
}

// 修改当前订购号码状态
export function editMobileStatus(params) {
  return request({
    url: "/yangguang/editMobileStatus",
    method: "post",
    params: params,
    metaValue: "修改当前订购号码状态"
  });
}

// 获取当前可投放省份
export function getOpenCity(params) {
  return request({
    url: "/yangguang/getOpenCity",
    method: "get",
    params: params,
    metaValue: "获取当前可投放省份"
  });
}

// 自营-腾讯广告平台投放回传
export function txPostCallBack(params) {
  return request({
    url: "/orderSelf/noToken/postTencentCallBack",
    method: "post",
    params: params,
    metaValue: "自营-腾讯广告平台投放回传"
  });
}

// 视宣号精英版-跳转小程序
export function makeCardScheme(params) {
  return request({
    url: "/doyenprice/makeCardScheme",
    method: "get",
    params: params,
    metaValue: "视宣号精英版-跳转小程序"
  });
}

// 视宣号精英版-咪咕sdk参数获取
export function VaGetMiguSdk(params) {
  return request({
    url: "/miguauth/orderSxhByHfive",
    method: "get",
    params: params,
    metaValue: "咪咕sdk参数获取"
  });
}

// 视宣号精英版-退订时获取成员uid
export function tdphonegetId(params) {
  return request({
    url: "/orderSelf/noToken/phoneSelect",
    method: "post",
    params: params,
    metaValue: "退订时获取成员uid"
  });
}

// 自营下单3.0
export function addOrderListSelfThreeNew(params) {
  return request({
    url: "/orderSelf/noToken/addOrderListSelfThreeNew",
    method: "post",
    params: params,
    metaValue: "自营下单3.0"
  });
}

// 视宣号精英版获取是否已订购
export function getOrderStatus(params) {
  return requestXnh({
    url: "/sxhopenorder/query",
    method: "get",
    params: params,
    metaValue: "获取是否已订购",
    onlyParams: true
  });
}

// 视宣号精英版获取是否有主叫功能
export function getCallStatus(params) {
  return requestXnh({
    url: "/sxhopenorder/queryVrbtStatus",
    method: "get",
    params: params,
    metaValue: "获取是否有主叫功能",
    onlyParams: true
  });
}

// 主叫视频彩铃内容免费订购并设置接口
export function freeOrder(params) {
  return requestXnh({
    url: "/sxhopenorder/freeOrder",
    method: "post",
    params: params,
    metaValue: "主叫视频彩铃内容免费订购并设置接口",
    onlyParams: true
  });
}

// 视宣号精英版-专区彩铃获取验证码
export function zqGetCode(params) {
  return request({
    url: "/orderSelf/noToken/sendSmsCode",
    method: "post",
    params: params,
    metaValue: "专区彩铃获取验证码"
  });
}

// 视宣号精英版-根据渠道uid获取用户信息
export function getQudaoInfoByUid(params) {
  return request({
    url: "/orderSelf/noToken/getBuyerInfo",
    method: "post",
    params: params,
    metaValue: "根据渠道uid获取用户信息"
  });
}

// 添加操作记录 用于埋点信息
export function insertTcmInternetUseraction(params) {
  return request({
    url: "/useraction/insertTcmInternetUseraction",
    method: "post",
    params: params,
    metaValue: "添加操作记录"
  });
}

// 设置商户彩铃-得到商户信息
export function getCircleList(params) {
  return requestXnh({
    url: "/sxhopenorder/getCircleList",
    method: "post",
    params: params,
    metaValue: "设置商户彩铃-得到商户信息",
    onlyParams: true
  });
}

// 设置商户彩铃
export function ringOperate(params) {
  return requestXnh({
    url: "/sxhopenorder/ringOperate",
    method: "post",
    params: params,
    metaValue: "设置商户彩铃",
    onlyParams: true
  });
}

// ------------------------------- 对接博鸿迅驰天籁接口 ----------------------------------
export function getSmsCodeForTl(params) {
  return request({
    url: "/tforderlist/noToken/miguMusic/getSmsCode",
    method: "post",
    params: params,
    metaValue: "获取验证码"
  });
}

export function submitcodeForTl(params) {
  return request({
    url: "/tforderlist/noToken/miguMusic/submitcode",
    method: "post",
    params: params,
    metaValue: "提交验证码"
  });
}



// WEBPACK FOOTER //
// ./src/api/api/common.js